<script setup lang="ts">
import type { TNewsSidebarItem } from '~/components/entity/news'
import type { IResponseData } from '~/types'
import type { IProps } from './types'
import { EntityArticlesSidebarItem } from '~/components/entity/articles/sidebar-item'

const { t } = useI18n()

const props = withDefaults(defineProps<IProps>(), {
  path: '/news',
  variant: 'default'
})

const headingText = computed(() => props.heading || t('widget.sidebar.news_heading'))

const url = computed(() => useUrlWithParams(props.path, props.queryParams))

const { data: news } = useApi<IResponseData<TNewsSidebarItem[]>>(() => url.value, {
  key: `sidebar-news.${url.value}`
})
</script>

<template>
  <SidebarBlock v-if="news?.data?.length" :heading-text="headingText">
    <div
      v-for="(item, index) in news.data"
      :key="item.id"
      :class="[{ 'border-t pt-4': index !== 0 }]"
    >
      <EntityArticlesSidebarItem v-bind="item" />
    </div>
    <footer class="text-right">
      <Button as-child>
        <NuxtLinkLocale to="/useful-articles">{{
          $t('widget.sidebar_articles.all_articles')
        }}</NuxtLinkLocale>
      </Button>
    </footer>
  </SidebarBlock>
</template>
